import Destinations from './styled';

export default Destinations;
